import React from 'react';
import "./skills.css";
import "./skills.scss";
import { FaJava, FaPython, FaNodeJs } from 'react-icons/fa';
import { SiSpringboot, SiFlask, SiPostgresql, SiMongodb, SiRedis } from 'react-icons/si';

const Backend = () => {
  return (
    <div className="skills__content box-top-right">
        <h3 className="skills__title">Backend</h3>

        <div className="skills__box">
            <div className="skills__group">
                <div className="skills__data">
                    <FaJava size={20} />
                    <div>
                        <h3 className="skills__name">Java</h3>
                        <span className="skills__level"></span>
                    </div>
                </div>

                <div className="skills__data">
                    <SiSpringboot size={20} />
                    <div>
                        <h3 className="skills__name">Spring Boot</h3>
                        <span className="skills__level"></span>
                    </div>
                </div>

                <div className="skills__data">
                    <FaPython size={20} />
                    <div>
                        <h3 className="skills__name">Python</h3>
                        <span className="skills__level"></span>
                    </div>
                </div>
            </div>

            <div className="skills__group">
                <div className="skills__data">
                    <SiFlask size={20} />
                    <div>
                        <h3 className="skills__name">Flask</h3>
                        <span className="skills__level"></span>
                    </div>
                </div>

                <div className="skills__data">
                    <SiPostgresql size={20} />
                    <div>
                        <h3 className="skills__name">PostgreSQL</h3>
                        <span className="skills__level"></span>
                    </div>
                </div>

                <div className="skills__data">
                    <SiMongodb size={20} />
                    <div>
                        <h3 className="skills__name">MongoDB</h3>
                        <span className="skills__level"></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Backend